// Leftovers from LayoutManager deprecation. Should be retired if/when possible.
export const shouldDisplayResultsAppliedDesktop = (ctx = {}) => {
  return !(ctx?.isDynamicBrandPage && ctx?.channel !== 'mobile');
};

export const shouldDisplayResultsAppliedMobile = (ctx = {}) => {
  return !(!ctx?.isDynamicBrandPage || ctx?.channel === 'mobile');
};

export const shouldDisplaySearchFeedback = (ctx = {}) => {
  return ctx?.isDebugMode;
};